import script from "./StepBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./StepBilling.vue?vue&type=script&setup=true&lang=js"

import "./StepBilling.vue?vue&type=style&index=0&id=142a5842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142a5842"]])

export default __exports__